import { useEffect, useState } from "react";
import { SunIcon, MoonIcon } from "@phosphor-icons/react";

const KEY = "agroport_theme";

export function applyInitialTheme() {
  const saved = localStorage.getItem(KEY);
  const theme = saved === "light" || saved === "dark" ? saved : "dark";
  document.documentElement.setAttribute("data-theme", theme);
  return theme;
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => document.documentElement.getAttribute("data-theme") || "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      title={theme === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      aria-label={theme === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      className="p-2 min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0 flex items-center justify-center rounded-lg border border-border text-agro-yellow hover:text-agro-yellow hover:border-agro-yellow/60 focus:outline-none focus:border-agro-yellow focus:ring-2 focus:ring-agro-yellow/30 transition-all"
    >
      {theme === "dark" ? <SunIcon size={18} weight="duotone" /> : <MoonIcon size={18} weight="duotone" />}
    </button>
  );
}
